export const evergabeSubmenuData = (windowWidth) =>
  windowWidth >= 1024
    ? [
        {
          type: "DropdownMenu",
          label: "Produkt",
          link: "/evergabe/produkt",
          page: "evergabe",
          dropdown_menu_items: [
            {
              type: "SubmenuLink",
              label: "Städte und Kommunen",
              link: "/evergabe/staedte-und-kommunen",
            },
            {
              type: "SubmenuLink",
              label: "Architekten und Planer",
              link: "/evergabe/planer-und-dienstleister",
            },
            {
              type: "SubmenuLink",
              label: "Gewerblich ausschreiben",
              link: "/evergabe/gewerblich-ausschreiben",
            },
          ],
        },
        {
          type: "SubmenuLink",
          label: "Preise",
          link: "/evergabe/preise",
        },
        {
          type: "SubmenuLink",
          label: "Dienstleistungen",
          link: "/evergabe/verfahrensabwicklung",
        },
        {
          type: "SubmenuLink",
          label: "Umsteigen",
          link: "/evergabe/umsteigen",
        },
        {
          type: "DropdownMenu",
          label: "Support",
          link: "/evergabe/support",
          page: "evergabe",
          dropdown_menu_items: [
            {
              type: "SubmenuLink",
              label: "VHB Formblätter",
              link: "/evergabe/support/formblaetter",
            },
            {
              type: "SubmenuLink",
              label: "Bekanntmachungsmuster",
              link: "/evergabe/support/vorlagen-bekanntmachungen",
            },
            {
              type: "SubmenuLink",
              label: "Ausschreibungen veröffentlichen",
              link: "/evergabe/support/veroeffentlichen",
            },
          ],
        },
        {
          type: "SubmenuLink",
          label: "Seminare",
          link: "/evergabe/veranstaltungen-und-seminare",
        },
        {
          type: "SubmenuLink",
          label: "Hilfe",
          link: "/evergabe/hilfe",
        },
        {
          type: "CTAButton",
          label: "Kostenfreie Demo",
          link: "/evergabe/demo-buchen",
        },
      ]
    : [
        {
          type: "CTAButton",
          label: "Kostenfreie Demo",
          mobile: true,
          link: "/evergabe/demo-buchen",
        },
      ]
